<template>
  <section>
    <!-- 注册 -->
    <van-dialog v-model="isRegister" title="用户中心" :show-confirm-button="false">
      <div class="form-close" @click="isLogin=isRegister=false">
        <img src="../../assets/images/icon/close.png"/>
      </div>
      <van-row class="form-register">
        <van-row class="item">
          <van-col class="icon">
            <img src="../../assets/images/icon/accout.png"/>
          </van-col>
          <van-col class="content">
            <input v-model="form.userName" placeholder="字母开头，5-16位数字或字母"/>
          </van-col>
        </van-row>
        <van-row class="item">
          <van-col class="icon">
            <img src="../../assets/images/icon/password.png"/>
          </van-col>
          <van-col class="content">
            <input type="password" v-model="form.password" placeholder="请输入密码"/>
          </van-col>
        </van-row>
        <van-row class="item">
          <van-col class="icon">
            <img src="../../assets/images/icon/password.png"/>
          </van-col>
          <van-col class="content">
            <input type="password" v-model="form.rePassword" placeholder="请重新输入密码"/>
          </van-col>
        </van-row>
      </van-row>
      <van-row class="form-button">
        <van-button type="primary" @click="handleConfirm(1)">立即注册</van-button>
      </van-row>
      <van-row class="other-tips">
        <a @click="openKF()" style="float: left" v-show="showKF">专属客服链接</a>
        <a @click="openUserDialog(1)" style="float: right">账号登录</a>
      </van-row>
    </van-dialog>
    <!-- 登录 -->
    <van-dialog v-model="isLogin" title="用户中心" :show-confirm-button="false">
      <div class="form-close" @click="isLogin=isRegister=false">
        <img src="../../assets/images/icon/close.png"/>
      </div>
      <van-row class="form-register">
        <van-row class="item">
          <van-col class="icon">
            <img src="../../assets/images/icon/accout.png"/>
          </van-col>
          <van-col class="content">
            <input v-model="form.userName" placeholder="请输入账号"/>
          </van-col>
        </van-row>
        <van-row class="item">
          <van-col class="icon">
            <img src="../../assets/images/icon/password.png"/>
          </van-col>
          <van-col class="content">
            <input type="password" v-model="form.password" placeholder="请输入密码"/>
          </van-col>
        </van-row>
      </van-row>
      <van-row class="form-button">
        <van-button type="primary" @click="handleConfirm(2)">立即登录</van-button>
      </van-row>
      <van-row class="other-tips">
        <a @click="openKF()" style="float: left" v-show="showKF">专属客服链接</a>
        <a @click="openUserDialog(2)" style="float: right">账号注册</a>
      </van-row>
    </van-dialog>
  </section>
</template>
<script>

export default {
  name: 'UserAuth',
  //ref=UserAuthView
  //successFun=authSuc
  props: {
    showKF: {
      type: Boolean,
      default: false
    },
    //String,Number,Boolean,Array,Object,Date,Function,Symbol
  },
  data() {
    return {
      form: {
        userName: '',
        password: '',
        rePassword: ''
      },
      isLogin: false,
      isRegister: false,
      chData: '',
      defaultData: "NTdicjY4NWJy",
      mRunRomSystem: "android",
      kfUrl: "",
    }
  },
  created() {
    this.chData = this.$route.query.ch;
    this.mRunRomSystem = this.runRomSystem();
  },
  mounted() {

  },
  methods: {
    authSuc() {
      this.$emit('authSuc');
    },
    showRegister() {
      this.isRegister = true;
    },
    setKfUrl(kfUrl) {
      this.kfUrl = kfUrl;
    },
    //用户中心确认   1为注册 ，2为登录
    handleConfirm(type) {
      if (!this.form.userName) {
        this.BRToast('请输入账号');
        return false;
      }
      if (!this.form.password) {
        this.BRToast('请输入密码');
        return false;
      }
      if (type === 1) {
        this.doRegister();
      } else {
        this.doLogin();
      }
    },

    doRegister() {
      if (this.form.password !== this.form.rePassword) {
        this.BRToast('两次密码输入不一致，请重新输入');
        return false;
      }
      let params = {
        chData: this.chData ? this.chData : this.defaultData,
        ...this.form,
        reqSys: "wapWeb",
        runRomSys: this.mRunRomSystem,
      }
      this.$http(window.config.userHomeApi + '/tg/register/user_name', params).then((res) => {
        this.isRegister = false;
        this.authSuc();
      });
    },

    doLogin() {
      let params = {
        chData: this.chData ? this.chData : this.defaultData,
        ...this.form,
        reqSys: "wapWeb",
        runRomSys: this.mRunRomSystem,
      }
      this.$http(window.config.userHomeApi + '/tg/login/user_name', params).then((res) => {
        this.isLogin = false;
        this.authSuc();
      });
    },

    //切换弹框
    openUserDialog(type) {
      Object.keys(this.form).forEach(key => {
        this.form[key] = '';
      })
      if (type === 1) {
        this.isRegister = false;
        this.isLogin = true;
      } else {
        this.isRegister = true;
        this.isLogin = false;
      }
    },
    openKF() {
      if (!this.kfUrl) {
        this.BRToast('客服信息未设置');
        return false;
      }
      document.location.href = this.kfUrl;
    },
  }
}
</script>

<style scoped lang='less'>
@import "../../assets/css/home/index.less";
</style>


// WEBPACK FOOTER //
// UserAuth.vue?b0024d0e